import { render, staticRenderFns } from "./card_list_card.vue?vue&type=template&id=50ab5d38&scoped=true&"
import script from "./card_list_card.vue?vue&type=script&lang=js&"
export * from "./card_list_card.vue?vue&type=script&lang=js&"
import style0 from "./card_list_card.vue?vue&type=style&index=0&id=50ab5d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab5d38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItemContent,VListItemSubtitle,VRow})
